/* eslint-disable */
const mutations = {
  setSendMethods(state, { sendMethods }) {
    state.data = sendMethods;
  },
};

export default mutations;
